import getRequest from "../getRequest"
import queryString from 'query-string'

export default function requestReset(email) {
  const BASE_URL = 'https://us-central1-bellwork-cg1.cloudfunctions.net/selfResetPassword'
  const request = `${BASE_URL}?${queryString.stringify({email})}`
  return getRequest(request)
}


// WEBPACK FOOTER //
// ./src/helpers/users/requestReset.js